(function($, viewport) {

    var angeboteCount = $('.angebot .angebotWaehlen.true').length;

    $(document).ready(function() {

        // Viewport Class zu body hinzufügen
        $('body').addClass(viewport.current());
        $(window).resize(
            viewport.changed(function() {
                $('body').removeClass('xs sm md lg xl').addClass(viewport.current());
            }, 500)
        );

        // zeige Detailinfo pro Angebot
        $('.detailInfo.collapse').on('show.bs.collapse', function() {
            $(this).closest('.angebot').addClass('open');
            eventTracking('Details anzeigen', 'Landingpage (v2)', $(this).closest('.angebot').prop('id'));
        });

        // verberge Detailinfo pro Angebot
        $('.detailInfo.collapse').on('hide.bs.collapse', function() {
            $(this).closest('.angebot').removeClass('open');
            eventTracking('Details verbergen', 'Landingpage (v2)', $(this).closest('.angebot').prop('id'));
        });

        // $('body .angebot').on('click', 'a', function() {
        //     eventTracking('Klick auf Angebotslink', 'Landingpage (v2)', $(this).prop('href'));
        // });

        // Angebot wählen
        $('.angebot .angebotWaehlen').click(function() {
            var $btn = $(this);
            $btn.toggleClass('true');
            if ($btn.hasClass('true')) {
                waehlenAnimation($btn);
            }
            anfrageKorb($btn);
        });

        // Angebot entfernen (Anfragekorb)
        $('.angebotForm_entf').click(function(e) {
            e.preventDefault();
            angebotForm_entf($(this).closest('li').prop('id'));
        });

        // Zeige Formular(e)
        $('.xs .zeigeForm, .sm .zeigeForm, .md .zeigeForm').click(function() { // Mobile Mode
            $('#blackout').removeClass('d-none');
            if ($(this).data('form') === 'kataloge' || $(this).data('form') === 'newsletter') {
                // $('#'+$(this).data('form')).removeClass('d-none');
                $('#' + $(this).data('form')).show();
            }
            $('#stickyTopHolder, body').removeClass('sticky-top').addClass('offCanvasForm ' + $(this).data('form'));
            eventTracking('Formular anzeigen', 'Landingpage (v2)', $(this).data('form'));
        });
        $('.lg .zeigeForm, .xl .zeigeForm').click(function() { // Desktop Mode
            if ($(this).data('form') === 'kataloge' || $(this).data('form') === 'newsletter') {
                // $('form#kataloge, form#newsletter').addClass('d-none');
                $('form#kataloge, form#newsletter').fadeOut('fast');
                if (!$(this).hasClass('active')) {
                    // $('#'+$(this).data('form')).removeClass('d-none');
                    $('#' + $(this).data('form')).fadeIn(400, function() {
                        $("html, body").animate({
                            scrollTop: $(document).height()
                        }, "slow");
                    });
                    $(this).addClass('active');
                    eventTracking('Formular anzeigen', 'Landingpage (v2)', $(this).data('form'));
                } else {
                    // $('#'+$(this).data('form')).addClass('d-none');
                    $('#' + $(this).data('form')).fadeOut('fast');
                    $(this).removeClass('active');
                    eventTracking('Formular schliessen', 'Landingpage (v2)', $(this).data('form'));
                }
            }
            if ($(this).data('form') === 'newsletter') {
                $('#btnNlCat .btn[data-form="kataloge"]').removeClass('active');
            }
            if ($(this).data('form') === 'kataloge') {
                $('#btnNlCat .btn[data-form="newsletter"]').removeClass('active');
            }
        });

        // Schließe Formular(e)
        $('#stickyTopHolder .closeForm').click(function() {
            $('#stickyTopHolder, body').removeClass('offCanvasForm anfrage newsletter kataloge');
            $('#stickyTopHolder').addClass('sticky-top');
            if ($(this).closest('form').prop('id') === 'kataloge' || $(this).closest('form').prop('id') === 'newsletter') {
                $(this).closest('form').hide();
            }
            $('#blackout').addClass('d-none');
            eventTracking('Formular schliessen', 'Landingpage (v2)', $(this).closest('form').prop('id'));
        });

        // Kein Zeitraum bekannt
        $('#keinZeitraum').change(function() {
            $('#anreise').prop('disabled', function(i, v) {
                return !v;
            });
            $('#abreise').prop('disabled', function(i, v) {
                return !v;
            });
        });

        // Reisezeitraum unbekannt - Checkbox
        $('.ttgFormReisezeitraumUnbekannt').change(function() {
            $('#anreise').prop('disabled', function(i, v) {
                return !v;
            });
            $('#abreise').prop('disabled', function(i, v) {
                return !v;
            });
        });

        // count down
        $('.btn-minus').click(function(e) {
            e.preventDefault();
            var $input = $(this).closest('.input-group').find('input');
            var value = $input.val();
            var valuesArr = smartCountValues($input.prop('id'), $('#content').data('lang'));
            $.each(valuesArr, function(i, v) {
                if (value === v.label) {
                    var index = i - 1;
                    if (index >= 0) {
                        $input.val(valuesArr[index].label);
                        kinderAlterHack($input.prop('id'), valuesArr[index].value);
                    }
                }
            });
        });

        // count up
        $('.btn-plus').click(function(e) {
            e.preventDefault();
            var $input = $(this).closest('.input-group').find('input');
            var value = $input.val();
            var valuesArr = smartCountValues($input.prop('id'), $('#content').data('lang'));
            $.each(valuesArr, function(i, v) {
                if (value === v.label) {
                    var index = i + 1;
                    if (index < valuesArr.length) {
                        $input.val(valuesArr[index].label);
                        kinderAlterHack($input.prop('id'), valuesArr[index].value);
                    }
                }
            });
        });

        //Anreise und Abreise
        const today = formatDateforDatepicker(new Date());
        $('#anreise').prop({
            'value': today,
            'min': today
        });

        // Setze Defaultdatum Abreise (in 3 Tagen)
        let today3 = new Date();
        today3.setDate(today3.getDate() + 3);
        today3 = formatDateforDatepicker(today3);

        $('#abreise').prop({
            'value': today3,
            'min': today
        });

        $('#anreise').change(function() {
            let vonDatum = $(this).val();
            let changedDatum = new Date(vonDatum);

            // Abreisedatum holen
            let bisDatum = $('#abreise').val();

            // + 2 Tage und das bisDatum korrigieren
            changedDatum.setDate(changedDatum.getDate() + 1);

            // Monat korrigieren
            month = ((changedDatum.getMonth() + 1) < 10) ? '0' + (changedDatum.getMonth() + 1) : (changedDatum.getMonth() + 1);
            day = (changedDatum.getDate() < 10) ? '0' + changedDatum.getDate() : changedDatum.getDate();


            // nur wenn das gewählte vonDatum größer als das hinterlegte bisDatum ist, soll das bisDatum um + 1 Tag erhöht werden
            if (vonDatum >= bisDatum) {
                // bisDatum darf nicht vor dem vonDatum liegen
                $('#abreise').prop({
                    'value': changedDatum.getFullYear() + '-' + month + '-' + day,
                    'min': changedDatum.getFullYear() + '-' + month + '-' + day
                });
            } else {
                // StartDate darf nicht vor dem vonDatum liegen
                $('#abreise').prop({
                    'min': changedDatum.getFullYear() + '-' + month + '-' + day
                });
            }
        });

        $('#kategorien a').click(function(e) {
            kategorieAusURL($(this).attr('href').replace('#', ''));
        });

        $('#kataloge').on('click', '.kataloge.error .form-check-input', function(e) {
            validation($('#kataloge')); // Revalidierung wenn Katalog-Checkbox Klick
        });

        $('#newsletter').on('click', '.newsletters.error .form-check-input', function(e) {
            validation($('#newsletter')); // Revalidierung wenn Newsletter-Checkbox Klick
        });

        //captcha bei allen Formularen hinterlegen
        if ($("form .google-recaptcha").length) {
            $('form .recaptcha-consent input[type="checkbox"]').on('change', function() {
                if ($(this).is(':checked') && $('.grecaptcha-badge').length == 0) {
                    var sitekey = $("#anfrage").find('.google-recaptcha').data('sitekey');
                    var head = document.getElementsByTagName('head')[0];
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallbackAnfrage&render=' + sitekey;
                    script.setAttribute('defer', '');
                    head.appendChild(script);
                }
            });
        }

        $('form').on('click', 'button.btn.google-recaptcha').submit(function(e) {
            e.preventDefault();
            submitForm($(this));
            console.log($(this)[0]['id']);
            if ($(this)[0]['id'] == 'anfrage') {
                eventTracking('Landingpage / Anfrage senden', 'Submit', 'clicked');
            } else if ($(this)[0]['id'] == 'newsletter') {
                eventTracking('Landingpage / Newsletter bestellt', 'Submit', 'clicked');
            } else if ($(this)[0]['id'] == 'kataloge') {
                eventTracking('Landingpage / Katalog bestellt', 'Submit', 'clicked');
            }
        });

        $('form').on('click', '.reloadForm', reloadForm);

        $.each($('.preis'), function(i, v) {
            $(this).text($(this).text().replace('.', ','));
        });

        $('a[href*="//"]').click(function(e) {
            eventTracking('Klick auf Link', 'Landingpage (v2)', $(this).prop('href'));
        });

        $('a[href^="mailto:"]').click(function(e) {
            eventTracking('Klick auf E-Mail Adresse', 'Landingpage (v2)', $(this).prop('href').replace('mailto:', ''));
        });

        $('.carousel a').click(function(e) {
            eventTracking('Slider Steuerung', 'Landingpage (v2)', $(this).data('slide'));
        });

        // $('#cookieAlert').on('closed.bs.alert', function () {
        //     Cookies.set('showCookieHinweis', 'false', { expires: 30, path: '/' });
        // });

        // initFunc
        anfrageKorb();
        kategorieAusURL();
        angebotAusURL();
        $('#anzeigegruppe').val(paramAusURL('anzeigegruppe')); // Schreibe Anzeigegruppe in Hidden Field > für Kampagnensteuerung
        $('#utm_source').val(paramAusURL('utm_source')); // Schreibe utm_source in Hidden Field > für Kampagnensteuerung
        $('#utm_campaign').val(paramAusURL('utm_campaign')); // Schreibe utm_campaign in Hidden Field > für Kampagnensteuerung
        $('#utm_medium').val(paramAusURL('utm_medium')); // Schreibe utm_medium in Hidden Field > für Kampagnensteuerung
        $('input.referrer').val(window.location.href);
        checkObAngebotInKategorie();
        // theming(); // nicht notwendig in LIVE Betrieb - LIVE einfach gewünschte Klasse auf body setzen und CSS einbinden
        $('[data-toggle="tooltip"]').tooltip();
        $('.smartCountInput').each(function() {
            smartCountValues($(this).prop('id'), $('#content').data('lang'), $(this));
        });
        // if (Cookies.get('showCookieHinweis') == null) {
        //     $('#cookieAlert').addClass('show');
        // }

        // Copyright Bilder
        $(document).on('click', '.ttgCopyright', function(e) {
            e.preventDefault();
            if ($(this).children('.ttgCopyrightIcon ').is(":visible")) {
                $(this).children('.ttgCopyrightIcon ').hide();
                $(this).children('.ttgCopyrightText').show();
                $(this).children('.ttgCopyrightText').children('button').focus();
            } else {
                $(this).children('.ttgCopyrightIcon').show();
                $(this).children('.ttgCopyrightText').hide();
                $(this).children('.ttgCopyrightIcon').focus();
            }
        });

    });

    var formatDateforDatepicker = function($date) {

        let d = ($date.getDate() < 10) ? '0' + $date.getDate() : $date.getDate();
        const mFix = $date.getMonth() + 1;
        let m = (mFix < 10) ? '0' + mFix : mFix;

        return $date.getFullYear() + '-' + m + '-' + d;
    };

    var anfrageKorb = function($btn) {

        // Anzahl der gewählten Angebote
        angeboteCount = $('.angebot .angebotWaehlen.true').length;
        // $('#stickyBottom .ausgewaehlt').animate({
        //   opacity: 0.5
        // }, 500);
        $('#stickyBottom .count').text(angeboteCount);

        // Angebot wählen Aktionen
        $.each($('.angebot .angebotWaehlen'), function() {
            tauscheHerzerl($(this)); // Tausche Herzerl
            if (!$btn && $(this).hasClass('true')) {
                angebotForm_hinzu($(this)); // initial
            }
        });
        if ($btn && $btn.hasClass('true')) {
            angebotForm_hinzu($btn);
        }
        if ($btn && !$btn.hasClass('true')) {
            angebotForm_entf($btn.closest('.angebot').prop('id'));
        }

        // Behandle Einzal/Mehrzahl
        if (angeboteCount === 1) {
            $('#stickyBottom .plural').hide();
        } else {
            $('#stickyBottom .plural').show();
        }

    };

    var tauscheHerzerl = function($btn) {

        // beim Angebot
        var $icon = $btn.find('span.fa-heart');
        var $btnText = $btn.find('span.text');
        if ($btn.hasClass('true')) {
            $icon.removeClass('far').addClass('fas');
            $btnText.text($('#angebotsSpalte').data('textGewaehlt'));
        } else {
            $icon.removeClass('fas').addClass('far');
            $btnText.text($('#angebotsSpalte').data('textWaehlen'));
        }

        // in stickyBottom
        var $countHerzerl = $('#stickyBottom .fa-heart');
        if (angeboteCount === 0) {
            $countHerzerl.addClass('far').removeClass('fas');
            $('#anfrageKorb ul').addClass('d-none');
        } else {
            $countHerzerl.addClass('fas').removeClass('far');
            $('#anfrageKorb ul').removeClass('d-none');
        }

    };

    var waehlenAnimation = function($btn) {

        $('#stickyBottom .fa-heart').addClass('beatFast');
        $('#blackout').removeClass('d-none');
        setTimeout(function() {
            $('#blackout').addClass('d-none');
            // }, 500);
            // setTimeout(function() {
            $('#stickyBottom .fa-heart').removeClass('beatFast');
        }, 2000);

    };

    var angebotForm_hinzu = function($btn) {

        var $angebot = $btn.closest('.angebot');
        var $id = $angebot.prop('id');
        var $template = $('#anfrageKorb .template');
        var $li = $template.clone(true).removeClass('template d-none');

        $li.find('img').prop('src', $angebot.find('img').prop('src'));
        $li.find('h3').text($angebot.find('h3').text());
        $li.find('.preis').text($angebot.find('.preis').text());
        $li.prop('id', $id + '_anfrageKorb');
        $li.data({
            email: $angebot.data('email'),
            tourdataid: $angebot.data('tourdataid')
        });

        $('#anfrageKorb').removeClass('invisible').find('ul').append($li);

        $('#anfrageKorb .invalid-feedback').addClass('d-none');

        updateMailto();
        updateAngebote();
        eventTracking('Angebot auswählen', 'Landingpage (v2)', $btn.closest('.angebot').prop('id'));

    };

    var angebotForm_entf = function(id) {

        if (id.indexOf('_anfrageKorb') > 0) {
            // Klick entfernen aus Anfragekorb
            $('#' + id.replace('_anfrageKorb', '')).find('.angebotWaehlen').trigger('click');
        } else {
            // Klick entfernen aus Angebotsliste (wird immer ausgelöst)
            $('#' + id + '_anfrageKorb').remove();

            updateMailto();
            updateAngebote();
            eventTracking('Angebot entfernen', 'Landingpage (v2)', id.replace('_anfrageKorb', ''));

        }

    };

    var theming = function() { // not in LIVE Betrieb

        // Themen (achtung auch im CSS definieren)
        var themes = {
            'spring': ['#F59C43', '#F5BF43', '#f9d991', '#567A11', '#89AB46', '#b8cc8f', '#3C3C3C', '#DDDDDD', '#FFF'],
            'ooetg': ['#0c7280', '#e6e100', '#f2ef7e', '#21828f', '#28b9cd', '#a0dfe8', '#3C3C3C', '#DDDDDD', '#FFF']
        };

        if (getURLParameter('style')) {

            var theme = getURLParameter('style'); // gewünschtes Theme

            // theming nur anwenden wenn es ein entsprechendes Theme gibt, ansonsten Standard "spring" verwenden
            if (themes[theme]) {

                // change stylesheet
                var themeStyle = $('#themeStyle').prop('href');
                $('#themeStyle').prop('href', themeStyle.replace('spring', theme));

                // change dummyPics
                // $.each($('img'), function(i,v){
                //   var src = $(v).prop('src');
                //   $.each(themes.spring, function(ci,cv){
                //     var cleanCv = cv.replace('#','');
                //     if( src.indexOf(cleanCv)>0 ){
                //       var newSrc = src.replace( cleanCv, themes[theme][ci].replace('#','') );
                //       $(v).prop('src', newSrc );
                //     }
                //   });
                // });

                $('body').addClass(theme).removeClass('spring');

            } else {
                console.log('Kein Theme mit dem Namen "' + theme + '" gefunden! Standardtheme "spring" angewandt!');
            }

        }

    };

    var kategorieAusURL = function(hash) {

        var kategorie = false;
        var dontTrack = false;
        if (hash) {
            kategorie = hash.replace('#', '');
        } else {
            if (getURLParameter('kat')) {
                kategorie = 'kat--' + getURLParameter('kat');
            } else if (getHashParameter('kat')) {
                kategorie = 'kat--' + getHashParameter('kat');
            } else {
                kategorie = 'kat--alle';
                dontTrack = true; // Event nicht auslösen weil "Normalfall"
            }
        }

        $('#angebote .angebot').fadeOut('fast');
        $('#angebote .' + kategorie).fadeIn('slow');
        $('#kategorien .active').removeClass('active');
        $('#kategorien a.' + kategorie + '').addClass('active');

        if (!dontTrack) {
            eventTracking('Kategorie auswählen', 'Landingpage (v2)', kategorie.replace('kat--', ''));
        }

    };

    var angebotAusURL = function() {

        var angebot = false;
        if (getURLParameter('angebot')) {
            angebot = '#' + getURLParameter('angebot');
        } else if (getHashParameter('angebot')) {
            angebot = '#' + getHashParameter('angebot');
        }

        if (angebot) {
            $(angebot + ' .angebotWaehlen').trigger('click');

            // Füge Angebot zu Anfragekorb hinzu und scrolle direkt zum Angebot
            $(angebot + ' .collapsed').trigger('click');
            $('html, body').animate({
                scrollTop: $(angebot).offset().top
            }, 1000);

            // schreibe in Hidden Field
            $('#angebotDirektHash').val(angebot.replace('#', ''));
        }

    };

    var paramAusURL = function(param) {

        var value = "";
        if (getURLParameter(param)) {
            value = getURLParameter(param);
        } else if (getHashParameter(param)) {
            value = getHashParameter(param);
        }
        return value;

    };

    var getURLParameter = function(name) {
        var value = decodeURIComponent((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [true, ""])[1]);
        return (value !== 'null') ? value : false;
    };

    var getHashParameter = function(name) {
        var value = decodeURIComponent((RegExp(name + '--' + '(.+?)(&|$)').exec(location.hash) || [true, ""])[1]);
        return (value !== 'null') ? value : false;
    };

    var checkObAngebotInKategorie = function() {

        $.each($('#kategorien li a'), function(i, v) {
            var kat = $(this).attr('href').replace('#', '');
            if (!$('.angebot.' + kat).length) {
                $(this).closest('li').remove();
            }
        });

    };

    var submitForm = function($form) {

        // var action = "/index.php?type=";
        var action = "/lp2k18-" + $form.prop('id') + ".html";

        // Formulardaten vorbereiten
        // switch ($form.prop('id')) {
        //
        //     case 'anfrage':
        //         action += "4642";
        //         break;
        //
        //     case 'kataloge':
        //         action += "4643";
        //         break;
        //
        //     case 'newsletter':
        //         action += "4644";
        //         break;
        //
        // }
        $form.addClass('loading');
        if (validation($form)) {
            $form.find('.formBeforeSend').fadeOut('fast');
        } else {
            $form.removeClass('loading');
            return false;
        }

        // bei den Erwachsenen nur die Nr. übergeben
        if ($('#erwachsene').length > 0) {
            var adultsTmp = $('#erwachsene').val();
            var adultsAmout = adultsTmp.match(/\d+/g).map(Number);
            $('#erwachsene').val(adultsAmout);
        }

        var sendForm = function() {
        $.ajax({
            method: 'POST',
            // url: $form.prop('action'),
            url: action,
            data: $form.serialize(),
            beforeSend: function(xhr, o) {

                // console.log(o);
                // console.log(xhr);

            },
            success: function(response, status, xhr) {

                // console.log('SUCCESS');
                // console.log(response);
                // console.log(status);
                // console.log(xhr);
                $form.find('.formResponse').html(response);

            },
            error: function(xhr, status, error) {

                // console.log('ERROR');
                // console.log(xhr);
                // console.log(status);
                // console.log(error);
                if (error.length > 0) {
                    $form.find('.formResponse').html('<div class="alert alert-danger" role="alert"><p>' + status + ' ' + xhr.status + ': ' + error + '</p>&raquo; <a href="#" class="reloadForm">Formular neu laden</a></div>');
                } else {
                    $form.find('.formResponse').html('<div class="alert alert-danger" role="alert"><p>' + status + ' ' + xhr.status + '</p>&raquo; <a href="#" class="reloadForm">Formular neu laden</a></div>');
                }

            },
            complete: function(xhr, status) {

                // console.log('COMPLETE');
                // console.log(xhr);
                // console.log(status);
                $form.removeClass('loading');
                $form.find('.formResponse').fadeIn('slow');
                eventTracking('Formular absenden', 'Landingpage (v2)', $form.prop('id'));

            }
        });
        };

        // Vorm Absenden frisches reCAPTCHA-Token holen, da v3-Tokens nur 2 Minuten gültig sind und
        // das beim Consent-Klick geholte Token beim Absenden oft schon abgelaufen bzw. bereits von
        // einem anderen Formular verbraucht ist (timeout-or-duplicate)
        var sitekey = $form.find('.google-recaptcha').data('sitekey') || $("#anfrage").find('.google-recaptcha').data('sitekey');
        if (window.grecaptcha && sitekey) {
            grecaptcha.execute(sitekey, {
                action: 'submitAnfrage'
            }).then(function(token) {
                $form.find('input[type="hidden"][name$="[g-recaptcha-response]"]').val(token);
                sendForm();
            }).catch(function() {
                // Fallback: mit altem Token absenden statt Formular hängen zu lassen
                sendForm();
            });
        } else {
            sendForm();
        }
    };

    var reloadForm = function(e) {
        e.preventDefault();
        $form = $(this).closest('form');
        $form.removeClass('was-validated');
        $form.find('.formResponse').fadeOut('fast');
        $form.find('.formBeforeSend').fadeIn('slow');
        eventTracking('Formular (zurück zum)', 'Landingpage (v2)', $form.prop('id'));
    };

    var validation = function($form) {

        $form.addClass('was-validated');

        var invalidStandard = $form.find('.form-control:invalid, .custom-select:invalid, .form-control.is-invalid, .custom-select.is-invalid').length;

        var invalidNoAllgemein = false;
        var invalidNoKataloge = false;
        var invalidNoNewsletter = false;

        switch ($form.prop('id')) {

            case "anfrage":
                // Check ob Angebot gewählt = keine allgemeine Anfrage möglich
                if ($form.find('#mailtoAllgemein').val() === '-') {
                    if ($form.find('#anfrageKorb li:not(.template)').length < 1) {
                        invalidNoAllgemein = true;
                        $form.find('#anfrageKorb').removeClass('invisible');
                        $form.find('.formTeaser .invalid-feedback').removeClass('d-none').show();
                    }
                }
                break;

            case "kataloge":
                // Check ob mind. 1 Katalog gewählt
                if (!$form.find('.form-check-input:checked').length) {
                    invalidNoKataloge = true;
                    $form.find('.formTeaser .invalid-feedback').removeClass('d-none').show();
                    $form.find('.kataloge').addClass('error');
                } else {
                    $form.find('.formTeaser .invalid-feedback').addClass('d-none').hide();
                    $form.find('.kataloge').removeClass('error');
                }
                break;

            case "newsletter":
                // Check ob mind. 1 NL gewählt - bei InsiderOne (OCC-14) ist die Interessen-Auswahl
                // optional (kein Pflichtfeld, siehe Partials/Newsletter.html), daher hier nicht erzwingen
                if ($form.data('insiderOneActive')) {
                    $form.find('.formTeaser .invalid-feedback').addClass('d-none').hide();
                    $form.find('.newsletters').removeClass('error');
                } else if (!$form.find('.form-check-input:checked').length) {
                    invalidNoNewsletter = true;
                    $form.find('.formTeaser .invalid-feedback').removeClass('d-none').show();
                    $form.find('.newsletters').addClass('error');
                } else {
                    $form.find('.formTeaser .invalid-feedback').addClass('d-none').hide();
                    $form.find('.newsletters').removeClass('error');
                }
                break;

        }

        if (invalidStandard || invalidNoAllgemein || invalidNoKataloge || invalidNoNewsletter) {
            return false;
        } else {
            return true;
        }

    };

    var smartCountValues = function(id, lang, $init) {

        var smartValues = {
            'de': {
                'erwachsene': [{
                    "value": 1,
                    "label": "1 Erwachsene(r)"
                },
                {
                    "value": 2,
                    "label": "2 Erwachsene"
                },
                {
                    "value": 3,
                    "label": "3 Erwachsene"
                },
                {
                    "value": 4,
                    "label": "4 Erwachsene"
                },
                {
                    "value": 5,
                    "label": "5 Erwachsene"
                },
                {
                    "value": 6,
                    "label": "6 Erwachsene"
                },
                {
                    "value": 7,
                    "label": "7 Erwachsene"
                },
                {
                    "value": 8,
                    "label": "8 Erwachsene"
                },
                {
                    "value": 9,
                    "label": "9 Erwachsene"
                },
                {
                    "value": 10,
                    "label": "10 Erwachsene"
                }
                ],
                'kinder': [{
                    "value": 0,
                    "label": "0 Kinder"
                },
                {
                    "value": 1,
                    "label": "1 Kind"
                },
                {
                    "value": 2,
                    "label": "2 Kinder"
                },
                {
                    "value": 3,
                    "label": "3 Kinder"
                },
                {
                    "value": 4,
                    "label": "4 Kinder"
                }
                ]
            },
            'en': {
                'erwachsene': [{
                    "value": 1,
                    "label": "1 adult"
                },
                {
                    "value": 2,
                    "label": "2 adults"
                },
                {
                    "value": 3,
                    "label": "3 adults"
                },
                {
                    "value": 4,
                    "label": "4 adults"
                },
                {
                    "value": 5,
                    "label": "5 adults"
                },
                {
                    "value": 6,
                    "label": "6 adults"
                },
                {
                    "value": 7,
                    "label": "7 adults"
                },
                {
                    "value": 8,
                    "label": "8 adults"
                },
                {
                    "value": 9,
                    "label": "9 adults"
                },
                {
                    "value": 10,
                    "label": "10 adults"
                }
                ],
                'kinder': [{
                    "value": 0,
                    "label": "0 children"
                },
                {
                    "value": 1,
                    "label": "1 child"
                },
                {
                    "value": 2,
                    "label": "2 children"
                },
                {
                    "value": 3,
                    "label": "3 children"
                },
                {
                    "value": 4,
                    "label": "4 children"
                }
                ]
            },
            'cz': {
                'erwachsene': [{
                    "value": 1,
                    "label": "1 dospělý"
                },
                {
                    "value": 2,
                    "label": "2 dospělí"
                },
                {
                    "value": 3,
                    "label": "3 dospělí"
                },
                {
                    "value": 4,
                    "label": "4 dospělí"
                },
                {
                    "value": 5,
                    "label": "5 dospělí"
                },
                {
                    "value": 6,
                    "label": "6 dospělí"
                },
                {
                    "value": 7,
                    "label": "7 dospělí"
                },
                {
                    "value": 8,
                    "label": "8 dospělí"
                },
                {
                    "value": 9,
                    "label": "9 dospělí"
                },
                {
                    "value": 10,
                    "label": "10 dospělí"
                }
                ],
                'kinder': [{
                    "value": 0,
                    "label": "0 dětí"
                },
                {
                    "value": 1,
                    "label": "1 dítě"
                },
                {
                    "value": 2,
                    "label": "2 děti"
                },
                {
                    "value": 3,
                    "label": "3 děti"
                },
                {
                    "value": 4,
                    "label": "4 děti"
                }
                ]
            },
            'it': {
                'erwachsene': [{
                    "value": 1,
                    "label": "1 adulto"
                },
                {
                    "value": 2,
                    "label": "2 adulti"
                },
                {
                    "value": 3,
                    "label": "3 adulti"
                },
                {
                    "value": 4,
                    "label": "4 adulti"
                },
                {
                    "value": 5,
                    "label": "5 adulti"
                },
                {
                    "value": 6,
                    "label": "6 adulti"
                },
                {
                    "value": 7,
                    "label": "7 adulti"
                },
                {
                    "value": 8,
                    "label": "8 adulti"
                },
                {
                    "value": 9,
                    "label": "9 adulti"
                },
                {
                    "value": 10,
                    "label": "10 adulti"
                }
                ],
                'kinder': [{
                    "value": 0,
                    "label": "0 bambini"
                },
                {
                    "value": 1,
                    "label": "1 bambino"
                },
                {
                    "value": 2,
                    "label": "2 bambini"
                },
                {
                    "value": 3,
                    "label": "3 bambini"
                },
                {
                    "value": 4,
                    "label": "4 bambini"
                }
                ]
            }
        };

        if ($init) {
            if (id === 'erwachsene') {
                $init.val(smartValues[lang][id][1].label);
            } else {
                $init.val(smartValues[lang][id][0].label);
            }
        } else {
            return smartValues[lang][id];
        }

    };

    var updateMailto = function() {

        var $adressenSpan = $('#infoEmail span');
        var adressen = [];

        $adressenSpan.empty();

        // adressen.push( $('input#mailtoAllgemein').val() );

        $.each($('#anfrageKorb li:not(.template)'), function(i, v) {
            adressen.push($(v).data('email'));
        });

        if (!adressen.length) { // wenn kein Angebot gewählt, nimm allgemeine E-Mail-Adresse
            adressen.push($('input#mailtoAllgemein').val());
        }

        Array.prototype.unique = function() {
            return this.filter(function(value, index, self) {
                return self.indexOf(value) === index;
            });
        };

        var mailtoString = adressen.unique().toString();
        $adressenSpan.text(mailtoString.replace(/,/g, ', '));
        $('input#mailto').val(mailtoString);

    };

    var updateAngebote = function() {

        var angebote = [];

        $.each($('#anfrageKorb li:not(.template)'), function(i, v) {
            var angebot = {
                tourdataId: $(v).data('tourdataid'),
                title: $(v).find('h3').text(),
                mailto: $(v).data('email')
            };
            angebote.push(angebot);
        });

        $('input#angebote').val(JSON.stringify(angebote));

    };

    // Event Tracking GA > Matomo in eventTracking.js
    var eventTracking = function(action, category, label, value, nonInteraction) {
        var tracking = {
            _enable: false,
            _f: 'eventTracking()',
            _tools: [],
            category: category,
            action: action,
            label: label,
            value: (value === undefined) ? false : value,
            nonInteraction: (nonInteraction === undefined) ? false : nonInteraction
        };

        if ($.cookie('cookieConsented-analysis') == '1') {
            if ($('#gaActive').length) {
                tracking._enable = true;
                tracking._tools.push('gtag');
                gtag('event', tracking.action, {
                    'event_category': tracking.category,
                    'event_label': tracking.label,
                    'value': tracking.value
                });
            }
        }

        if ($('#matomoTracking').length) {
            tracking._enable = true;
            tracking._tools.push('Matomo');
            _paq.push(['trackEvent', tracking.category, tracking.action, tracking.label, tracking.value]);
        }

        if (tracking._enable) {
            console.table("%c TTG Debug ", "background: #0080a3; color: #fff", tracking);
        }

    };

    var kinderAlterHack = function(id, value) {

        if (id === 'kinder') {
            switch (value) {
                case 0:
                    // $('').removeClass('d-none');
                    $('#kind1_alterInput, #kind2_alterInput, #kind3_alterInput, #kind4_alterInput').addClass('d-none').find('.kindAlter').val('');
                    break;
                case 1:
                    $('#kind1_alterInput').removeClass('d-none');
                    $('#kind2_alterInput, #kind3_alterInput, #kind4_alterInput').addClass('d-none').find('.kindAlter').val('');
                    break;
                case 2:
                    $('#kind1_alterInput, #kind2_alterInput').removeClass('d-none');
                    $('#kind3_alterInput, #kind4_alterInput').addClass('d-none').find('.kindAlter').val('');
                    break;
                case 3:
                    $('#kind1_alterInput, #kind2_alterInput, #kind3_alterInput').removeClass('d-none');
                    $('#kind4_alterInput').addClass('d-none').find('.kindAlter').val('');
                    break;
                case 4:
                    $('#kind1_alterInput, #kind2_alterInput, #kind3_alterInput, #kind4_alterInput').removeClass('d-none');
                    // $('').addClass('d-none').find('.kindAlter').value('');
                    break;
            }
        }

    };

})(jQuery, ResponsiveBootstrapToolkit);

window.onloadCallbackAnfrage = function() {
    grecaptcha.ready(function() {
        grecaptcha.execute($("#anfrage").find('.google-recaptcha').data('sitekey'), {
            action: 'submitAnfrage'
        }).then(function(token) {
            // bei allen Formularen das token in das entsprechende hidden field schreiben
            $('#anfrage input[type="hidden"][name="tx_ttglandingpage2k18_view[anfrage][g-recaptcha-response]"]').val(token);

            if ($('#newsletter input[type="hidden"][name="tx_ttglandingpage2k18_view[newsletter][g-recaptcha-response]"]').length) {
                $('#newsletter input[type="hidden"][name="tx_ttglandingpage2k18_view[newsletter][g-recaptcha-response]"]').val(token);
            }

            if ($('#kataloge input[type="hidden"][name="tx_ttglandingpage2k18_view[kataloge][g-recaptcha-response]"]').length) {
                $('#kataloge input[type="hidden"][name="tx_ttglandingpage2k18_view[kataloge][g-recaptcha-response]"]').val(token);
            }
        });
    });
};
